import { render, staticRenderFns } from "./UsersSeatsManagerModal.template.vue?vue&type=template&id=1325771e&scoped=true&"
var script = {}
import style0 from "./UsersSeatsManagerModal.template.vue?vue&type=style&index=0&id=1325771e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325771e",
  null
  
)

export default component.exports